import { c as _c } from "react/compiler-runtime";
import { Badge } from '@systemeio/components';
import React, { type ReactNode } from 'react';
import { TrendTriangleDownIcon, TrendTriangleUpIcon } from 'shared/components/chart/trend-triangle-icons';
type ChartTrendDirection = 'down' | 'up';
type ChartTrendTone = 'error' | 'neutral' | 'success';
interface ChartTrendBadgeProps {
  children: ReactNode;
  direction: ChartTrendDirection;
  tone: ChartTrendTone;
}

/*
 * The triangle points at the actual movement while the tone carries whether that movement is good,
 * so an inverted metric can fall and still read as a success. `!` beats the `outlinedGray` icon
 * color the badge sets for its own children.
 */
const toneIconClassNames: Record<ChartTrendTone, string> = {
  error: 'text-icon-error!',
  neutral: '',
  success: 'text-icon-success!'
};
const ChartTrendBadge = t0 => {
  const $ = _c(8);
  const {
    children,
    direction,
    tone
  } = t0;
  const TrendIcon = direction === "up" ? TrendTriangleUpIcon : TrendTriangleDownIcon;
  const t1 = toneIconClassNames[tone];
  let t2;
  if ($[0] !== TrendIcon || $[1] !== t1) {
    t2 = <TrendIcon className={t1} />;
    $[0] = TrendIcon;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = <span className="text-base">{children}</span>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Badge color="outlinedGray" shape="rounded" size="lg">{t2}{t3}</Badge>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export { ChartTrendBadge };
export type { ChartTrendBadgeProps, ChartTrendDirection, ChartTrendTone };